import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import Dashboard from './components/Dashboard';
import WalkingDistanceCalculator from './components/WalkingDistanceCalculator';
import StreetAnalyzer from './components/StreetAnalyzer';
import OpenSpaceAnalyzer from './components/OpenSpaceAnalyzer';
import SpaceSyntax from './components/SpaceSyntax';
import DPAnalyzer from './components/DPAnalyzer';
import UrbanWiki from './components/UrbanWiki';
import AdminPanel from './components/AdminPanel';
import ResetPassword from './components/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          {/* Login is a popup on the landing page. Any lingering /login link or
              bookmark funnels there instead of the old standalone page. */}
          <Route path="/login" element={<Navigate to="/?login=1" replace />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/walking-calculator"
            element={
              <ProtectedRoute>
                <WalkingDistanceCalculator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/street-analysis"
            element={
              <ProtectedRoute>
                <StreetAnalyzer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/open-space"
            element={
              <ProtectedRoute requiredPermission="open_space:view">
                <OpenSpaceAnalyzer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/space-syntax"
            element={
              <ProtectedRoute requiredPermission="space_syntax:view">
                <SpaceSyntax />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dp-analysis"
            element={
              <ProtectedRoute>
                <DPAnalyzer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/urban-wiki"
            element={
              <ProtectedRoute requiredPermission="urban_wiki:view">
                <UrbanWiki />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
